import * as React from "react";
import {Col, Row} from "react-bootstrap";
import {Afiliacion} from "../../modelo/Documento";
import {obtenerTipoIdentificacion} from "../../modelo/TiposIdentificacion";
import {Oficina} from "../../../general/modelo/Oficina";
import {EstadoDocumento} from "../../modelo/EstadosDocumento";
import ModalRecepcion from "./ModalRecepcion";
import ModalAnular from "./ModalAnular";
import ModalMensajeAprobacion from "./ModalMensajeAprobacion";
import ModalMensajeEnProceso from "./ModalMensajeEnProceso";
import ModalMensajeRechazo from "./ModalMensajeRechazo";

export default class InformacionBasicaRecepcion extends React.Component<InformacionBasicaRecepcionProps> {

    render() {
        const {afiliacion} = this.props;
        return (
            <div className={"card"}>
                <div className={"card-header"}>
                    <h3 className={"panel-title"}>Información Básica</h3>
                </div>
                <div className={"card-body"}>
                    <Row className="form-group">
                        <Col sm={3}>
                            <label className={"ltitle"}>Tipo Documento:</label>
                        </Col>
                        <Col sm={3} className={"text-left"}>
                            <label className={"label-text"}>
                                {obtenerTipoIdentificacion(afiliacion.afiliado.identificacion.charAt(0)).name}
                            </label>
                        </Col>
                        <Col sm={3}>
                            <label className={"ltitle"}>No. Documento:</label>
                        </Col>
                        <Col sm={3}>
                            <label className={"label-text"}>{afiliacion.afiliado.identificacion.substring(1)}</label>
                        </Col>
                    </Row>
                    <Row className="form-group">
                        <Col sm={3}>
                            <label className={"ltitle"}>Nombre Legal:</label>
                        </Col>
                        <Col sm={3}>
                            <label className={"label-text"}>{afiliacion.afiliado.nombreLegal}</label>
                        </Col>
                        <Col sm={3}>
                            <label className={"ltitle"}>Nombre Comercial:</label>
                        </Col>
                        <Col sm={3}>
                            <label className={"label-text"}>{afiliacion.afiliado.nombreComercial}</label>
                        </Col>
                    </Row>
                    <Row className="form-group">
                        <Col sm={3}>
                            <label className={"ltitle"}>Tipo Cliente:</label>
                        </Col>
                        <Col sm={3}>
                            <label className={"label-text"}>{afiliacion.tipoCliente.nombre}</label>
                        </Col>
                        <Col sm={3}>
                            <label>Estado</label> <br/>
                        </Col>
                        <Col sm={3}>
                            <label className={"label-text"}>{afiliacion.estado}</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3}>
                            <label>Acciones</label> <br/>
                        </Col>
                        <Col sm={3}>
                        {
                            afiliacion.estado === EstadoDocumento.pendiente  || afiliacion.estado === EstadoDocumento.rechazado ?
                                <ModalRecepcion dni={afiliacion.afiliado.identificacion}
                                                tipoCliente={afiliacion.tipoCliente}/> :
                            afiliacion.estado === EstadoDocumento.anulado ? 
                                <ModalAnular dni={afiliacion.afiliado.identificacion}
                                                tipoCliente={afiliacion.tipoCliente}/> :
                            afiliacion.estado === EstadoDocumento.aprobado ? 
                                <ModalMensajeAprobacion/>:
                            afiliacion.estado === EstadoDocumento.recibidoVerificacion ? 
                                <ModalMensajeEnProceso tipoCliente={afiliacion.tipoCliente.nombre}/> :
                            afiliacion.estado === EstadoDocumento.enProceso ? 
                                <ModalMensajeEnProceso tipoCliente={afiliacion.tipoCliente.nombre}/> :
                            afiliacion.estado === EstadoDocumento.rechazado ? 
                                <ModalMensajeRechazo/> :
                                                "N/A"
                        }
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }

}

interface InformacionBasicaRecepcionProps {
    afiliacion: Afiliacion,
    oficinas: Array<Oficina>
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/InformacionBasicaRecepcion.tsx